<template>
  <h4 v-if="type === MenuChildType.SUBHEADER" class="iorder-menu-item-subheader">{{ text }}</h4>
  <p v-else class="iorder-menu-item-text">{{ text }}</p>
</template>

<script setup lang="ts">
import type { ItemTextDividerProps } from './types';
import { MenuChildType } from '@/types/menu';

defineProps<ItemTextDividerProps>();
</script>

<style lang="scss">
@import './scss/ItemTextDivider.scss';
</style>
